import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'am',
    fullName: 'Amharic',
    nativeName: 'አማርኛ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "አንድ አስደናቂ ነገር እየመጣ ነው።",
    landing_subtitle: "ArgVoid መተግበሪያ እና የጨዋታ ልማት ስቱዲዮ ነው። ይከታተሉ ፣ አዲስ ነገሮች በቅርቡ ይመጣሉ!",
    select_language: "ቋንቋ ይምረጡ",
    search_placeholder: "ቋንቋዎችን ፈልግ...",
    terms_title: "የአገልግሎት ውል",
    policy_title: "የግላዊነት ፖሊሲ",
    cookies_title: "የኩኪ ፖሊሲ",
    terms_content: `
        <strong>1. ውሎች</strong><br> መቀበል
        ArgVoidን በማግኘት እነዚህ የአገልግሎት ውሎች ይቀበላሉ። እነዚህ ውሎች ካልተስማሙ አገልግሎቱ ጥቅም ላይ መዋል የለበትም።<br><br>

        <strong>2. የመሳሪያ ስርዓት አጠቃቀም</strong><br>
        ArgVoid እና አፕሊኬሽኖቹ ለመረጃ እና ለፈጠራ ዓላማዎች “እንደሆነ” ቀርበዋል። አገልግሎቱ ለሕጋዊ ዓላማዎች ብቻ ጥቅም ላይ መዋል አለበት.<br><br>

        <strong>3. የተከለከለ ምግባር</strong><br>
        የጣቢያ ተጋላጭነቶችን መበዝበዝ፣ አይፈለጌ መልእክት መላክ ወይም ያልተፈቀደ የመሠረተ ልማት ተጠቃሚ ለመሆን መሞከር በጥብቅ የተከለከለ ነው።<br><br>

        <strong>4. ማስተባበያ</strong><br>
        መድረኩ እና አገልግሎቶቹ በማንኛውም ጊዜ ያለማሳወቂያ ሊሻሻሉ ይችላሉ። የአገልግሎቱን ቆይታ ወይም ተገኝነት በተመለከተ ምንም አይነት ዋስትና አይሰጥም።
    `,
    policy_content: `
        <strong>1. የመረጃ ስብስብ</strong><br>
        መድረኩ በዚህ ጊዜ የተጠቃሚን ማረጋገጥ ወይም መለያ መፍጠርን አይፈልግም። ምንም አይነት የግል መለያ መረጃ (እንደ ስሞች ወይም ኢሜል አድራሻዎች) ከጎብኚዎች በንቃት አልተሰበሰበም።<br><br>

        <strong>2. አጠቃቀም Data</strong><br>
        የጣቢያን ትራፊክ ለመረዳት እና መተግበሪያዎቹን ለማሻሻል መሰረታዊ፣ ስም-አልባ ትንታኔዎች ሊሰበሰቡ ይችላሉ። ይህ ውሂብ ከግል የተጠቃሚ መለያዎች ጋር አልተገናኘም።<br><br>

        <strong>3. የሶስተኛ ወገን አገልግሎቶች</strong><br>
        የሶስተኛ ወገን አቅራቢዎች ለማስተናገጃ እና ለመተንተን አገልግሎት ሊውሉ ይችላሉ። የእነዚህ የሚመለከታቸው አቅራቢዎች የግላዊነት ልምምዶች በመሠረተ ልማታቸው ላይ የሚስተናገዱትን የማይታወቁ መረጃዎችን ይቆጣጠራሉ።<br><br>

        <strong>4. የውሂብ ደህንነት</strong><br>
        መድረኩን ለመጠበቅ ምክንያታዊ የደህንነት እርምጃዎች ይተገበራሉ። ሆኖም ግን, ምንም አይነት የበይነመረብ ስርጭት ዘዴ ሙሉ በሙሉ ደህንነቱ የተጠበቀ ነው.<br><br>
    `,
    cookies_content: `
        <strong>1. ኩኪዎች እና የአካባቢ ማከማቻ ምንድን ናቸው?</strong><br>
        ኩኪዎች እና የአሳሽ አካባቢያዊ ማከማቻ በመሳሪያው ላይ የተከማቹ ትንሽ የውሂብ ፋይሎች በጉብኝቶች ውስጥ ያሉ የማዋቀር ምርጫዎችን ለማስታወስ ነው።<br><br>

        <strong>2. የአጠቃቀም ዓላማ</strong><br>
        Browser LocalStorage እንደ:<br> ያሉ የውቅረት ቅንብሮችን ለማስቀመጥ በጥብቅ ጥቅም ላይ ይውላል
        - የቋንቋ ምርጫዎች<br>
        - የተጠቃሚ በይነገጽ ውቅር (ለምሳሌ፣ አቀማመጥ ወይም ገጽታ ቅንብሮች)<br>
        - ጊዜያዊ መተግበሪያ መሸጎጫ<br><br>

        <strong>3. ምንም Tracking</strong><br> የለም።
        ኩኪዎች እና የአካባቢ ማከማቻዎች ለማስታወቂያ ወይም ለሶስተኛ ወገን ክትትል ዓላማዎች ጥቅም ላይ አይውሉም። ሁሉም የተከማቸ ውሂብ ለመሣሪያ ስርዓቱ ዋና ተግባር ነው.<br><br>

        <strong>4. Control</strong><br>
        የአሳሽ ውሂብ በማንኛውም ጊዜ በአሳሽ ቅንጅቶች ሊጸዳ ይችላል, ይህም ማንኛውንም የአካባቢ ውቅረቶችን ዳግም ያስጀምራል.
    `,
    cookie_consent_text: "እንደ ክፍለ-ጊዜዎን ንቁ ማድረግ፣ የቋንቋ ምርጫዎን ማስቀመጥ እና ሌሎች ብጁ ውቅሮችን የመሳሰሉ የድር ጣቢያውን ተግባራት በትክክል ለማረጋገጥ መሰረታዊ ኩኪዎችን እንጠቀማለን።",
    read_policy: "የኩኪ ፖሊሲን ያንብቡ",
    support_title: "ድጋፍን ያነጋግሩ",
    support_subject_label: "ርዕሰ ጉዳይ",
    support_message_label: "መልእክት",
    support_submit_button: "መልእክት ላክ",
    support_hint: "ማሳሰቢያ፡ ይህ መልእክቱን ለመላክ ነባሪ የኢሜል መተግበሪያዎን ይከፍታል።",
    support_success_msg: "የኢሜል መተግበሪያዎን በመክፈት ላይ...",
    support_error_msg: "መልዕክት መላክ አልተሳካም። እባክዎ ቆይተው እንደገና ይሞክሩ።",
    explorer_title: "አሳሽ",
    history_title: "ታሪክ",
    animation_title: "አኒሜሽን",
    config_title: "ማዋቀር",
    tool_mouse: "ይምረጡ (Ctrl+M)",
    tool_brush: "ብሩሽ (Ctrl+B)",
    tool_brush_mode: "ሁነታ ቀያይር (ጠንካራ/ግልጽ)",
    tool_eraser: "ኢሬዘር (Ctrl+E)",
    tool_brush_size: "የብሩሽ መጠንን ያስተካክሉ",
    tool_bucket: "ሙላ (Ctrl+F)",
    tool_eyedropper: "የዓይን ጠብታ",
    tool_grid: "ፍርግርግ (Ctrl+Shift+B)",
    tool_rotate: "አሽከርክር (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "V ገልብጥ (Ctrl+Shift+V)",
    tool_transpose: "ማስተላለፍ (Ctrl+Shift+T)",
    label_width: "ስፋት",
    label_height: "ቁመት",
    label_frames: "የክፈፎች ብዛት",
    label_animation: "የአኒሜሽን ዘይቤ",
    label_background_color: "የበስተጀርባ ቀለም",
    label_interval: "ክፍተት",
    tool_anim_config: "የአኒሜሽን ውቅር",
    label_new_width: "አዲስ ስፋት",
    label_new_height: "አዲስ ቁመት",
    label_apply: "ያመልክቱ",
    label_colors: "ቀለሞች",
    label_size: "መጠን",
    label_tolerance: "መቻቻል",
    val_horizontal: "አግድም",
    val_vertical: "አቀባዊ",
    val_sequence: "ቅደም ተከተል",
    val_bounce: "መወርወር",
    val_random: "በዘፈቀደ",
    val_solid: "ድፍን",
    val_clear: "ግልጽ",
    action_add_sheet: "አዲስ ሉህ",
    action_import: "አስመጣ",
    action_export: "ወደ ውጪ ላክ",
    action_sort_projects: "ደርድር",
    sort_date_old: "በጣም ጥንታዊው መጀመሪያ",
    sort_date_new: "አዲሱ መጀመሪያ",
    sort_name_az: "ስም (A-Z)",
    sort_name_za: "ስም (Z-A)",
    action_new_sprite: "አዲስ Sprite",
    action_new_project: "አዲስ ፕሮጀክት",
    modal_save_all_title: "ሁሉንም ለውጦች ያስቀምጡ",
    modal_save_all_desc: "ለማስቀመጥ ንብረቶቹን ይምረጡ፡-",
    modal_save_selected: "የተመረጠውን ያስቀምጡ",
    action_saved: "ተቀምጧል",
    modal_create_sprite_title: "አዲስ Sprite ፍጠር",
    modal_create_project_title: "አዲስ ፕሮጀክት ይፍጠሩ",
    modal_add_sheet_title: "አዲስ ሉህ ጨምር",
    modal_rename_sheet_title: "ሉህ እንደገና ይሰይሙ",
    modal_rename_sprite_title: "ስፕሪትን እንደገና ይሰይሙ",
    modal_delete_sprite_title: "Spriteን ሰርዝ",
    modal_delete_project_title: "ፕሮጀክት ሰርዝ",
    modal_delete_sheet_title: "ሉህ ሰርዝ",
    placeholder_sprite_name: "ስም",
    placeholder_project_name: "ስም",
    placeholder_sheet_name: "ስም",
    placeholder_new_name: "አዲስ ስም",
    action_create: "ፍጠር",
    action_add: "አክል",
    action_rename: "እንደገና ይሰይሙ",
    action_duplicate: "ማባዛት።",
    action_delete: "ሰርዝ",
    action_cancel: "ሰርዝ",
    confirm_delete_sprite: "እርግጠኛ ነዎት ይህን sprite መሰረዝ ይፈልጋሉ?",
    confirm_delete_project: "እርግጠኛ ነዎት ይህን ፕሮጀክት መሰረዝ ይፈልጋሉ? ሁሉም sprites ይወገዳሉ.",
    confirm_delete_sheet: "እርግጠኛ ነዎት ይህን ሉህ መሰረዝ ይፈልጋሉ?",
    err_select_sprite: "እባክዎ መጀመሪያ sprite ይምረጡ።",
    err_select_project: "እባክዎ መጀመሪያ ፕሮጀክት ይምረጡ።",
    err_name_empty: "ስም ባዶ ሊሆን አይችልም።",
    err_sprite_exists: "ስሙ ያለው ስፕሪት አስቀድሞ አለ።",
    err_project_exists: "ይህ ስም ያለው ፕሮጀክት አስቀድሞ አለ።",
    err_no_content: "ምንም የሚቀመጥ ይዘት የለም።",
    err_no_changes: "ለማስቀመጥ ምንም ለውጦች የሉም።",
    err_delete_last_sheet: "የመጨረሻውን ሉህ መሰረዝ አልተቻለም።",
    err_extract_frames: "ምንም ፍሬሞች ማውጣት አልተቻለም።",
    err_indexeddb: "በአካባቢው ማስቀመጥ አልተሳካም። አሳሽህ IndexedDB ላይደግፍ ይችላል።",
    msg_upload_success: "ሰቀላው ተሳክቷል፡ {0}",
    msg_upload_failed: "ሰቀላው አልተሳካም፦ {0}",
    msg_save_success: "በተሳካ ሁኔታ ያስቀምጡ.",
    msg_saving: "በማስቀመጥ ላይ...",
    msg_multi_save_result: "{0} ንብረቶች ተቀምጠዋል። {1} አልተሳካም።",
    menu_title: "ምናሌ",
    menu_save: "አስቀምጥ",
    menu_save_all: "ሁሉንም አስቀምጥ",
    menu_support: "ድጋፍን ያነጋግሩ",
    label_local_storage: "የአካባቢ ማከማቻ",
    label_sign_in: "ይግቡ",
    modal_export_title: "Sprite ወደ ውጪ ላክ",
    label_filename: "የፋይል ስም",
    label_format: "ቅርጸት",
    action_export_confirm: "ወደ ውጪ ላክ",
};

export default translations;
